import { ISelectedSessionDetails } from "repoV2/features/Common/modules/FormData/interfaces/SessionDetailsFormGroup.interfaces";
import { IVariant } from "repoV2/features/Listing/Listing.interfaces";
import { LISTING_TYPES } from "repoV2/features/Listing/Listing.constants";
import { IOrderBumpsDetails } from "repoV2/features/CheckoutPages/modules/PaymentDetailsSection/modules/FormGroups/modules/OrderBumpsFormGroup/OrderBumpsFormGroup.interfaces";
import { IFormDataState } from "repoV2/features/Common/modules/FormData/interfaces/FormData";
import { IGeneratePaymentPayload, IListingMap } from "../Payments.interface";

/**
 * @dev this function processes listing and sessions data into listing_map value for payment payload
 */
export const generateListingMapDetails = (data: {
    listingType: number;
    sessionDetails?: ISelectedSessionDetails; // session Details for schedule offerings
    primaryListingUuid?: string; // checkout page primary listing uuid
    allListingDetails: IFormDataState["listingDetails"];
    installmentDetails: IGeneratePaymentPayload["installmentDetails"];
    orderBumpsDetails: IOrderBumpsDetails;
    variantDetails?: IVariant;
    dynamicLinkUuid: string;
    multipleUsersHeadCount?: number;
    merchandiseQuantity?: number;
}) => {
    const {
        listingType,
        primaryListingUuid,
        sessionDetails = {},
        allListingDetails,
        installmentDetails = {},
        orderBumpsDetails = {},
        variantDetails,
        dynamicLinkUuid = "",
        multipleUsersHeadCount,
        merchandiseQuantity = 1,
    } = data;

    const { slots, batches } = sessionDetails;

    const listingSpecificListingMapValues: IListingMap[keyof IListingMap] = {};

    switch (listingType) {
        case LISTING_TYPES.MERCHANDISE: {
            listingSpecificListingMapValues.quantity = merchandiseQuantity || 1;
            if (variantDetails?.uuid) {
                listingSpecificListingMapValues.variant_uid =
                    variantDetails.uuid;
            }
            break;
        }
        case LISTING_TYPES.GROUP_CLASSES:
        case LISTING_TYPES.ROLLING_CLASSES:
        case LISTING_TYPES.ONE_ON_ONE_CLASSES: {
            if (batches) {
                listingSpecificListingMapValues.class_uid = batches.value;
            }
            break;
        }
        case LISTING_TYPES.APPOINTMENTS:
        case LISTING_TYPES.WORKSHOPS:
        case LISTING_TYPES.WEBINAR: {
            if (slots) {
                listingSpecificListingMapValues.slot_uids = slots;
            }
            break;
        }
        default: {
            break;
        }
    }
    /**
     * TODO: @shivansh @mayankd2 need to handle listingMapValue for multiple listings checkout
     * for add to cart flow etc.
     * sample implementation can be seen here in `computeCommonPayload` at `src/redux/sagas/cart.ts`
     * either pass this value as prop or calculate here only
     * Currently support for
     * 1. single slot booking for Webinar
     * 1. single booking (quantity) for QPP.
     */
    let listingMapValue: IListingMap = {};
    if (primaryListingUuid) {
        const listingDetails = allListingDetails[primaryListingUuid] || {};
        const listingAppliedCouonCodeData =
            listingDetails.appliedCouponCodeDetails || {};

        listingMapValue[primaryListingUuid] = {
            quantity: 1,
            ...listingSpecificListingMapValues,
            ...(listingAppliedCouonCodeData.applied && {
                discount_code: listingAppliedCouonCodeData.couponCode,
            }),
            ...(installmentDetails.installmentUuid && {
                installment_uuid: installmentDetails.installmentUuid,
                payment_type: installmentDetails.paymentType,
            }),
            ...(dynamicLinkUuid && {
                dynamic_link_id: dynamicLinkUuid,
            }),
            ...(multipleUsersHeadCount && {
                head_count: multipleUsersHeadCount,
            }),
        };
        listingMapValue = {
            ...listingMapValue,
            ...orderBumpsDetails,
        };
    }
    return listingMapValue;
};
